// @flow
import React from 'react';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import CommentActions from 'app/components/CommentActions';
import CommentModeratorActions from 'app/components/CommentModeratorActions';
import styles from './PostCommentsItem.styles.js';

class PostCommentsItem extends React.Component<Props> {

  render() {
    const {classes, data} = this.props;
    const commentContent = data && data.content.replace(/\n|\r/g, '<br />');
    return (
      <article
        className={classNames(classes.comment, `post-comment-${data.id}`)}
      >
        <header className={classes.commentAuthor}>
          {data.author.name}
        </header>
        <div dangerouslySetInnerHTML={{__html: commentContent}} />
        <footer className={classes.tools}>
        {!this.props.isAdmin &&
          <CommentActions
            initData={{
              likes: data.like_count,
              dislikes: data.dislike_count,
            }}
            postId={data.postId}
            commentId={data.id}
            author={data.author.name}
          />
        }
        {this.props.isAdmin &&
          <CommentModeratorActions
            initData={{
              status: data.status
            }}
            postId={data.postId}
            commentId={data.id}
            author={data.author.name}
          />
        }
        </footer>
      </article>
    );
  }
}

const Component = withStyles(styles)(PostCommentsItem);
export {Component as PostCommentsItem};
export default Component;